export default "__VITE_ASSET__B4dB871d__"